module.exports = __webpack_public_path__ + "static/media/sasha-grey-lose.7d6a2d2c.jpg";